import { useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";

import { Home } from "pages";

import { baseConfig } from "config";
import LocalStorageHelper from "helpers/LocalStorageHelper";
import { DefaultLayout } from "layouts";
import LoadingLayout from "layouts/LoadingLayout";
import AADB2CConfirmLogin from "pages/Login/AADB2CConfirmLogin";
import PageSystemDisabled from "pages/SystemDisabled";
import { useCurrentUser } from "providers/CurrentUserProvider";
import BackofficeRoutes from "./backoffice";
import ExternalUserRouter from "./external-user";

// DO NOT CHANGE THIS PATH. This is used as the redirect URL and is set in the B2C configuration.
export const AADB2C_CONFIRM_LOGIN_PAGE_PATH = "/confirm-login";

function Routers() {
	const { pathname } = useLocation();
	const user = useCurrentUser();

	const isSystemEnabled = baseConfig.systemEnabled;
	const defaultRedirectUrl = user?.defaultRedirectUrl() ?? "/";

	useEffect(() => {
		setTimeout(() => {
			window.scrollTo({
				top: 0,
				left: 0,
				behavior: "smooth"
			});
		}, 100);
	}, [pathname]);

	useEffect(() => {
		if (pathname !== "/solicitacao")
			LocalStorageHelper.removeApplicationDraft();
	}, [pathname]);

	return !isSystemEnabled ? (
		<Routes>
			<Route path="/" element={<PageSystemDisabled />} />
			<Route path="/*" element={<Navigate to="/" />} />
		</Routes>
	) : user === undefined ? (
		<Routes>
			<Route path="*" element={<LoadingLayout />} />
		</Routes>
	) : (
		<Routes>
			{user?.isExternalUser() ? (
				<Route path="*" element={<ExternalUserRouter />} />
			) : (
				!user && (
					<>
						<Route path="/" element={<DefaultLayout />}>
							<Route path="/" element={<Home />} />
						</Route>
						<Route
							path={AADB2C_CONFIRM_LOGIN_PAGE_PATH}
							element={<AADB2CConfirmLogin />}
						/>
					</>
				)
			)}

			<Route path="/backoffice/*" element={<BackofficeRoutes />} />
			<Route path="*" element={<Navigate to={defaultRedirectUrl} />} />
		</Routes>
	);
}

export default Routers;
